function formatMaskedAccountNumber(accountNumber) {
  if (accountNumber == null || accountNumber === '') return '';
  const digits = String(accountNumber).replace(/\D/g, '');
  if (!digits) return String(accountNumber);
  const last4 = digits.slice(-4);
  return `**** ${last4}`;
}

export default formatMaskedAccountNumber;
